module.exports = __webpack_public_path__ + "img/tmx_kapcsolat.7a4f7d1d.jpg";